import { useAppDispatch, useAppSelector } from '../index';
import { updateCryptoConnect, updateCryptoDisconnect, fetchCustomerNonce } from '@ogsnetwork/opp-redux-lib';
export function useCustomerCryptoNonce() {
    const dispatch = useAppDispatch();
    const nonce = useAppSelector((state) => state.nonce.nonce);
    const status = useAppSelector((state) => state.nonce.status);
    function dispatchCustomerCryptoNonce(address) {
        dispatch(fetchCustomerNonce(address));
    }
    return {
        nonce,
        status,
        dispatchCustomerCryptoNonce
    };
}
export function useCryptoConnect() {
    const dispatch = useAppDispatch();
    const error = useAppSelector((state) => state.connect.error);
    function dispatchCryptoConnect(address, signature, disconnect) {
        if (disconnect) {
            dispatch(updateCryptoDisconnect({ address, signature }));
        }
        else {
            dispatch(updateCryptoConnect({ address, signature }));
        }
    }
    return {
        error,
        dispatchCryptoConnect
    };
}
